import { render } from "./EditUserSideNav.vue?vue&type=template&id=1ca46c59&scoped=true"
import script from "./EditUserSideNav.vue?vue&type=script&lang=js"
export * from "./EditUserSideNav.vue?vue&type=script&lang=js"

import "./EditUserSideNav.vue?vue&type=style&index=0&id=1ca46c59&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca46c59"]])

export default __exports__